// initial state
import docendo from '../../docendo'

const moment = extendMoment(Moment)
import Vue from 'vue'
import {extendMoment} from 'moment-range'
import Moment from 'moment'
import eventbus from '../../eventbus'

const state = {
  allUsers: [],
  allUsersAndEvents: null,
  allEvents: [],
  allDayEventsRaw: [],
  allEventsInAHash: {},
  allEventsWithMultipleTeachersOn: {},
  allCalsWithEventIdsInHash: {},
  allAbsenceEventInEventSerialIdsHash: {},
  date: moment().utc(),
  activeEvent: null,
  activeUser: null,
  schedulerActiveEvent: {'left': 0, 'right': 0, color: ''},
  absenceReasons: [],
  longAbsentList: [],
  isSortSubActive: false,
  sortSubs: 0,
  usersAndSubstituteHours: {},
  dataIsLoading: false,
  eventsRequestId: 0,
  sortingHierarchy: {
    canceledHours: 0,
    othersOnLesson: 3,
    isInSameClassAtTheSameTime: 6,
    hasHoursInClassOnDay: 9,
    availableHour: 12,
    presence: 15,
    multipleLessonsInSameClasses: 18,
    notOccupiedWithLessonsOnDay: 21,
    notOccupiedWithoutLessonsOnDay: 24,
    occupied: 27,
    absence: 30
  },
  activeAbsenceReason: null,
  isActiveAbsenceReasonIsReadyToDelete: false,
  activeAbsentUser: null,
  activeAbsentUserEvents: [],
  activeAbsentUserOriginalEvents: [],
  activeEvents: [],
  isActiveEventsLoading: false,
  theActiveEventsLoadingOnCalendarId: null
}

const getters = {
  allUsersSortedOnName: (state) => {
    const removeNullFromUsers = state.allUsers.filter(user => user.name !== null && user.name !== '')
    return Vue.prototype.$helpers.sortArrOnName(removeNullFromUsers)
  },
  allUsersSortedIds: (state, getters) => getters.allUsersSortedOnName.map(user => user.user_calendar_id),
  userSet: (state, getters) => getters.allUsersSortedIds.map(userId => state.allUsersAndEvents[userId]),
  absentUsersFromUserSet: (state, getters) => getters.userSet.filter(user => user.dayAbsence.length > 0),
  substitutesToday: (state, getters) => getters.userSet.filter(user => user.daySubEvents.length > 0),
  absentUsersGetDate: (state) => moment(state.date).format('YYYY_MM_DD'),
  absentUsersHandledHash: (state, getters) => {
    let hash = {}

    getters.absentUsersFromUserSet.forEach(user => {
      // 0 = none, 1 = handled, 2 = pending
      let userStatus = 1
      let isAnyEventsPending = false

      for (const dayAbsence of user.dayAbsence) {
        // Hent dagens events og filtrer events fra andre skoler væk
        const userEvents = user.dayEvents
          .map(dayEventId => state.allEventsInAHash[dayEventId])
          .filter(dayEvent => dayEvent && !dayEvent.v_is_event_from_other_school)

        // Tjek om brugeren ingen events har den dag, men status er ændret til 0
        if (userEvents.length === 0) {
          const absence = state.allEventsInAHash[dayAbsence] || {}
          const subStatus = absence.substitution_status ? JSON.parse(absence.substitution_status) : {}
          const status =
            subStatus[user.user_calendar_id] && subStatus[user.user_calendar_id].status !== undefined
              ? subStatus[user.user_calendar_id].status
              : 1
          if (status === 0) {
            userStatus = 0
            break // Tidligt exit - ingen grund til at tjekke videre
          }
        }

        // Tjek status for events
        for (const lesson of userEvents) {
          const absence = state.allEventsInAHash[dayAbsence] || {}
          const normalizedStart = moment(absence.start).millisecond(0)
          const normalizedEnd = moment(absence.end).millisecond(0)
          const absenceRange = moment.range(normalizedStart, normalizedEnd)
          const lessonRange = moment.range(lesson.start, lesson.end)

          if (absenceRange.overlaps(lessonRange)) {
            const subStatus = lesson.substitution_status ? JSON.parse(lesson.substitution_status) : {}
            const status = lesson.canceled === true ? 1 : subStatus[user.user_calendar_id] && subStatus[user.user_calendar_id].status !== undefined
              ? subStatus[user.user_calendar_id].status
              : 0
            if (status === 2) {
              isAnyEventsPending = true
            }

            const isUserSubstituted = lesson.calendar_events.some(
              function (calEvent) {
                return calEvent.substitute_for_user_id === user.id
              }
            )

            if (!isUserSubstituted && status === 0) {
              userStatus = 0
              break // Tidligt exit - ingen grund til at tjekke videre
            }
          }
        }
      }
      hash[user.id] = userStatus === 1 && isAnyEventsPending ? 2 : userStatus
    })

    return hash
  },
  absentUsersUnhandled: (state, getters) => {
    return getters.absentUsersFromUserSet.filter(user => {
      return !getters.absentUsersHandledHash[user.id]
    })
  },
  absentUsersHandled: (state, getters) => {
    return getters.absentUsersFromUserSet.filter(user => {
      return getters.absentUsersHandledHash[user.id]
    })
  },
  notAbsentUsersFromUserSet: (state, getters) => getters.userSet.filter(user => user.dayAbsence.length < 1),
  subsAbsenceReasonsSorted (state, getters) {
    return state.absenceReasons.sort((a, b) => {
      let nameA = a.name.toUpperCase().trim() // ignore upper and lowercase
      let nameB = b.name.toUpperCase().trim() // ignore upper and lowercase
      if (nameA < nameB) return -1
      if (nameA > nameB) return 1
      return 0
    })
  },
  longAbsentListInHash: (state, getters) => state.longAbsentList.reduce((obj, item) => {
    obj[item.id] = item
    return obj
  }, {}),
  usersWithOngoingAbsenceInHash: (state, getters) => {
    // let users = {1231: {absenceArr: [12, 33]}},
    let users = {}
    state.longAbsentList.filter(absence => absence.ongoing).forEach(absence => {
      if (!users[absence.calendar_id]) {
        Vue.set(users, absence.calendar_id, {absenceArr: [absence.id]})
      } else {
        users[absence.calendar_id].absenceArr.push(absence.id)
      }
    })
    return users
  },
  activeAbsentUserEventsInHash: (state, getters) => state.activeAbsentUserEvents.reduce((obj, item) => {
    obj[item.event_id] = item
    return obj
  }, {}),
  activeAbsentUserOriginalEventsInHash: (state, getters) => state.activeAbsentUserOriginalEvents.reduce((obj, item) => {
    obj[item.event_id] = item
    return obj
  }, {})
}

// evt. lille hjælper lokalt i modulet for at undgå duplikeret logik
function applySubPoolsToUser (item, state) {
  // brugte timer
  const hoursRaw = state.usersAndSubstituteHours && state.usersAndSubstituteHours[item.id]
  const used = hoursRaw !== undefined && hoursRaw !== null ? Number(hoursRaw) : 0

  // pool (kan være null eller string)
  let pool = 0
  if (item.current_user_year && item.current_user_year.substitute_pool_hours) {
    pool = Number(item.current_user_year.substitute_pool_hours)
  }

  // afrund stabilt til 1 decimal (undgå -4.90000001)
  const diff = pool - used
  const subPolsDiff = Math.round(diff * 10) / 10

  // vis brugt med 1 decimal som string (som du gjorde)
  const substituteHours = used.toFixed(1)

  Vue.set(item, 'substituteHours', substituteHours)
  Vue.set(item, 'subPoolsDiff', subPolsDiff)
}

function isAwayLesson (event) {
  return !!(event && event.away && event.event_type !== 'absence')
}

function userHasRealAbsence (state, calId) {
  const user = state.allUsersAndEvents && state.allUsersAndEvents[calId]
  if (!user || !user.dayAbsence) {
    return false
  }
  for (let i = 0; i < user.dayAbsence.length; i++) {
    const event = state.allEventsInAHash[user.dayAbsence[i]]
    if (event && event.event_type === 'absence') {
      return true
    }
  }
  return false
}

function moveEventId (fromArr, toArr, eventId) {
  if (!fromArr || !toArr) {
    return
  }
  const fromIdx = fromArr.indexOf(eventId)
  if (fromIdx > -1) {
    fromArr.splice(fromIdx, 1)
  }
  if (toArr.indexOf(eventId) < 0) {
    toArr.push(eventId)
  }
}

// Away-brikker vises som fravær, men på en person med rigtig absence
// skal de fremstå som almindelige lektioner, der kan vikardækkes.
function invalidateInFlightEventReloads (state) {
  state.eventsRequestId = (state.eventsRequestId || 0) + 1
}

function reclassifyAwayEventsForUser (state, calId) {
  const user = state.allUsersAndEvents && state.allUsersAndEvents[calId]
  if (!user) {
    return
  }
  const hasRealAbsence = userHasRealAbsence(state, calId)
  const sourceIds = hasRealAbsence
    ? (user.dayAbsence || []).slice()
    : (user.dayEvents || []).slice()
  for (let i = 0; i < sourceIds.length; i++) {
    const eventId = sourceIds[i]
    const event = state.allEventsInAHash[eventId]
    if (!isAwayLesson(event)) {
      continue
    }
    if (hasRealAbsence) {
      moveEventId(user.dayAbsence, user.dayEvents, eventId)
    } else {
      moveEventId(user.dayEvents, user.dayAbsence, eventId)
    }
  }
}

const mutations = {
  setSubDate (state, date) {
    state.date = moment(date).format('YYYY-MM-DD')
  },
  setAllUsers: (state, data) => {
    console.time('create User Arr')
    state.allUsers = data
    const users = state.allUsers

    const allUsers = users.reduce((obj, item) => {
      // init felter
      Vue.set(item, 'dayEvents', [])
      Vue.set(item, 'daySubEvents', [])
      Vue.set(item, 'dayAbsence', [])
      Vue.set(item, 'dayPresence', [])
      Vue.set(item, 'dayAllEvents', [])
      Vue.set(item, 'dayAvailability', [])
      Vue.set(item, 'canceledEvents', [])
      Vue.set(item, 'v_two_in_class_events', [])
      Vue.set(item, 'v_two_events_in_class_events', [])

      // sæt sub-pool felter ud fra nuværende state (måske tom i første omgang)
      applySubPoolsToUser(item, state)

      obj[item.user_calendar_id] = item
      return obj
    }, {})

    state.allUsersAndEvents = allUsers
    console.timeEnd('create User Arr')
  },
  addEventOnAllUsersWithEvents: (state, data) => {
    if (
      state.allUsersAndEvents[data.cal_id] &&
      state.allUsersAndEvents[data.cal_id].dayEvents &&
      !state.allUsersAndEvents[data.cal_id].dayEvents.includes(data.event_id)
    ) {
      state.allUsersAndEvents[data.cal_id].dayEvents.push(data.event_id)
    }
  },
  addANewEvent: (state, lesson) => {
    state.allEvents.push(lesson)
    state.allEventsInAHash[lesson.id] = lesson
    lesson.calendar_events.forEach(user => {
      // Only push into users
      if (state.allUsersAndEvents[user.calendar_id]) {
        state.allUsersAndEvents[user.calendar_id].dayEvents.push(lesson.id)
      }
    })
  },
  addAbsenceToUserInAllUsersWithEvents: (state, data) => {
    invalidateInFlightEventReloads(state)
    state.allUsersAndEvents[data.cal_id].dayAbsence.push(data.event_id)
    reclassifyAwayEventsForUser(state, data.cal_id)
  },
  removeAbsenceOnAllUsersWithEvents: (state, data) => {
    let idx = state.allUsersAndEvents[data.cal_id].dayAbsence.indexOf(data.event_id)
    if (idx > -1) {
      state.allUsersAndEvents[data.cal_id].dayAbsence.splice(idx, 1)
    }
  },
  removeEventOnAllUsersWithEvents: (state, data) => {
    let idx = state.allUsersAndEvents[data.cal_id].dayEvents.indexOf(data.event_id)
    if (idx > -1) {
      state.allUsersAndEvents[data.cal_id].dayEvents.splice(idx, 1)
    }
  },
  reclassifyAwayEventsForUser: (state, calId) => {
    reclassifyAwayEventsForUser(state, calId)
  },
  setAllEvents (state, data) {
    state.allEvents = data
    let events = state.allEvents
    state.allEventsInAHash = events.reduce((obj, item) => {
      obj[item.id] = item
      return obj
    }, {})
  },
  updateEventOnAllEventsInAHash (state, event) {
    Vue.set(state.allEventsInAHash, event.id, event)
  },
  updateTeacherNoteOnEvent (state, eventIdAndTeacherNote) {
    state.allEventsInAHash[eventIdAndTeacherNote.eventId].teacher_notes = eventIdAndTeacherNote.note
  },
  updateAllEventsWithMultipleTeachersOn (state, data) {
    Vue.set(state.allEventsWithMultipleTeachersOn, data.userAndEventIds, data.userCalIds)
  },
  updateSubStatusOnEvent (state, eventIdAndsubstitutionStatus) {
    state.allEventsInAHash[eventIdAndsubstitutionStatus.eventId].substitution_status = eventIdAndsubstitutionStatus.status
  },
  setActiveUser (state, data) {
    state.activeUser = data
  },
  setActiveEvent (state, data) {
    state.activeEvents = []
    state.activeEvent = data
  },
  clearActiveEvents (state) {
    state.activeEvents = []
  },
  setActiveEvents (state, dbEvent) {
    const idx = state.activeEvents.findIndex(e =>
      e.event_id === dbEvent.event_id &&
      e.calendar_id === dbEvent.calendar_id
    )

    if (idx !== -1) {
      // findes allerede → fjern
      state.activeEvents.splice(idx, 1)
    } else {
      // findes ikke → tilføj
      state.activeEvents.push(dbEvent)
    }
  },
  subsSetAbsenceReasons (state, data) {
    state.absenceReasons = data
  },
  subsAddNewAbsenceReason (state, data) {
    state.absenceReasons.push(data)
  },
  subsSetLongAbsentList (state, data) {
    state.longAbsentList = data
  },
  setIsSubScoreActive (state, boolean) {
    state.isSortSubActive = boolean
  },
  setUsersWithSubPools: (state, data) => {
    // 1) gem timerne
    state.usersAndSubstituteHours = data

    // 2) hvis brugere allerede er sat, opdater deres felter nu
    if (state.allUsers && state.allUsers.length) {
      for (let i = 0; i < state.allUsers.length; i++) {
        const item = state.allUsers[i]
        applySubPoolsToUser(item, state)

        // afspejl også i slå-op objektet hvis det findes
        if (state.allUsersAndEvents && item.user_calendar_id) {
          Vue.set(state.allUsersAndEvents, item.user_calendar_id, item)
        }
      }
    }
  },
  setSortSubsAgain () {
    state.sortSubs++
  },
  setCalsInAllCalsAndEvents (state, data) {
    Vue.set(state.allCalsWithEventIdsInHash, data.calid, {lessons: [data.eventid]})
  },
  addEventInAllCalsAndEvents (state, data) {
    state.allCalsWithEventIdsInHash[data.calid].lessons.push(data.eventid)
  },
  setSortingHierarchy (state, obj) {
    // Run trough each prop because obj doesn't include absence, occupied etc.
    // Older saved orders lack canceledHours — insert it at the top without colliding.
    const isMissingCanceledHours = !('canceledHours' in obj)
    const isMissingHasHoursInClassOnDay = !('hasHoursInClassOnDay' in obj)
    Object.entries(obj).forEach(([key, value]) => {
      state.sortingHierarchy[key] = isMissingCanceledHours ? value + 3 : value
    })
    if (isMissingCanceledHours) {
      const fixedDefaults = {
        notOccupiedWithoutLessonsOnDay: 18,
        occupied: 21,
        absence: 24
      }
      Object.entries(fixedDefaults).forEach(([key, def]) => {
        if (!(key in obj)) {
          state.sortingHierarchy[key] = def + 3
        }
      })
      state.sortingHierarchy.canceledHours = 0
    }
    // Older saved orders lack hasHoursInClassOnDay — insert after "in class at the same time".
    if (isMissingHasHoursInClassOnDay) {
      const insertAfter = state.sortingHierarchy.isInSameClassAtTheSameTime !== undefined
        ? state.sortingHierarchy.isInSameClassAtTheSameTime
        : 6
      Object.keys(state.sortingHierarchy).forEach(key => {
        if (key !== 'hasHoursInClassOnDay' && state.sortingHierarchy[key] > insertAfter) {
          state.sortingHierarchy[key] += 3
        }
      })
      state.sortingHierarchy.hasHoursInClassOnDay = insertAfter + 3
    }
  },
  setActiveAbsenceReason (state, obj) {
    state.activeAbsenceReason = obj
  },
  updateLongListAbsence (state, data) {
    let idx = state.longAbsentList.findIndex(absence => absence.id === data.id)
    Vue.set(state.longAbsentList, idx, data)
  },
  deleteLongListAbsenceItem (state, eventSerial) {
    let idx = state.longAbsentList.findIndex(absence => absence.id === eventSerial.eventSerialId)
    if (idx > -1) {
      state.longAbsentList.splice(idx, 1)
    }
  },
  setIsActiveAbsenceReasonIsReadyToDelete (state, boolean) {
    state.isActiveAbsenceReasonIsReadyToDelete = boolean
  },
  setActiveAbsentUser (state, user) {
    state.activeAbsentUser = user
  },
  setActiveAbsentUserEvents (state, events) {
    state.activeAbsentUserEvents = events
  },
  setActiveAbsentUserOriginalEvents (state, events) {
    state.activeAbsentUserOriginalEvents = events
  },
  setAllEventsOnUsers (state, data) {
    console.time('vuex::setAllEventsOnUsers')
    state.allDayEventsRaw = data
    const includeReservations = !!(this.state.schoolSettings && this.state.schoolSettings.includeReservationsInSubstitution)
    const events = includeReservations
      ? data
      : data.filter(event => event.event_type !== 'reservation')
    // Hack: vis ikke fravær der tilhører en anden skole
    const activeSchoolId = window.SCHOOL && window.SCHOOL.id ? window.SCHOOL.id * 1 : null
    const hideOtherSchoolAbsenceSchoolIds = [64228, 64229]
    const shouldHideOtherSchoolAbsence = hideOtherSchoolAbsenceSchoolIds.indexOf(activeSchoolId) > -1
    const eventsWithoutOtherSchoolAbsence = shouldHideOtherSchoolAbsence
      ? events.filter(event => {
        if (event.event_type !== 'absence') {
          return true
        }
        return !event.school_id || (event.school_id * 1) === activeSchoolId
      })
      : events
    let allEvents = eventsWithoutOtherSchoolAbsence
    this.commit('setAllEvents', eventsWithoutOtherSchoolAbsence)

    let usersWithEvents = state.allUsersAndEvents
    for (const key of Object.keys(usersWithEvents)) {
      Vue.set(usersWithEvents[key], 'dayAllEvents', [])
      Vue.set(usersWithEvents[key], 'dayEvents', [])
      Vue.set(usersWithEvents[key], 'daySubEvents', [])
      Vue.set(usersWithEvents[key], 'dayAbsence', [])
      Vue.set(usersWithEvents[key], 'dayPresence', [])
      Vue.set(usersWithEvents[key], 'subScore', [0, 0, 0])
      Vue.set(usersWithEvents[key], 'dayAvailability', [])
      Vue.set(usersWithEvents[key], 'canceledEvents', [])
      Vue.set(usersWithEvents[key], 'v_two_in_class_events', [])
      Vue.set(usersWithEvents[key], 'v_two_events_in_class_events', [])
    }

    // Ryd events for alle kalendere
    state.allCalsWithEventIdsInHash = {}
    state.allAbsenceEventInEventSerialIdsHash = {}
    const usersWithRealAbsence = {}
    for (let i = 0; i < allEvents.length; i++) {
      const event = allEvents[i]
      if (event.event_type !== 'absence' || !event.calendar_events) {
        continue
      }
      for (let j = 0; j < event.calendar_events.length; j++) {
        usersWithRealAbsence[event.calendar_events[j].calendar_id] = true
      }
    }
    // Opret kort over klasseevents baseret på `klassId`
    const klassEventsMap = {}
    // Gennemgå alle events og organisér dem efter klasse og tidspunkt
    for (let i = 0; i < allEvents.length; i++) {
      const event = allEvents[i]
      const klassEvents = event.calendar_events.filter(ce => ce.calendar_type === 'klass')

      klassEvents.forEach(klassEvent => {
        const klassId = klassEvent.calendar_id
        const start = event.start
        const end = event.end

        if (!klassEventsMap[klassId]) {
          klassEventsMap[klassId] = []
        }

        // Se om der allerede er en lektion med samme tid for denne klasse
        const overlapping = klassEventsMap[klassId].find(existingEvent =>
          existingEvent.start === start && existingEvent.end === end
        )
        klassEventsMap[klassId].push({start, end, event})
        if (overlapping) {
          // console.log(event.title + ' overlapper med ' + overlapping.event.title)
          overlapping.event.calendar_events.forEach(calEvent => {
            const userCalId = calEvent.calendar_id
            const user = usersWithEvents[userCalId]
            if (calEvent.calendar_type === 'user' && user) {
              usersWithEvents[userCalId].v_two_events_in_class_events.push(overlapping.event.id)
              usersWithEvents[userCalId].v_two_events_in_class_events.push(event.id)
            }
          })
          event.calendar_events.forEach(calEvent => {
            const userCalId = calEvent.calendar_id
            const user = usersWithEvents[userCalId]
            if (calEvent.calendar_type === 'user' && user) {
              const userCalId = calEvent.calendar_id
              usersWithEvents[userCalId].v_two_events_in_class_events.push(overlapping.event.id)
              usersWithEvents[userCalId].v_two_events_in_class_events.push(event.id)
            }
          })
        }
      })
    }
    // Gennemgå alle events for brugerne
    for (let i = 0; i < allEvents.length; i++) {
      const event = allEvents[i]
      if (event.calendar_events) {
        // Kontroller for to lærere og én klasse i dette event
        const userCount = event.calendar_events.filter(ce => ce.calendar_type === 'user').length
        const hasKlass = event.calendar_events.some(ce => ce.calendar_type === 'klass')
        const hasTwoOrMoreTeachersInClass = userCount > 1 && hasKlass

        for (let j = 0; j < event.calendar_events.length; j++) {
          const calendarEvent = event.calendar_events[j]
          const calId = calendarEvent.calendar_id

          // Tilføj event til "specialEvents", hvis kriterierne er opfyldt
          if (hasTwoOrMoreTeachersInClass && usersWithEvents[calId]) {
            usersWithEvents[calId].v_two_in_class_events.push(event.id)
          }

          // Tilføj til alle cals og lessonids
          if (state.allCalsWithEventIdsInHash[calId]) {
            this.commit('addEventInAllCalsAndEvents', {
              calid: calId,
              eventid: event.id
            })
          } else {
            this.commit('setCalsInAllCalsAndEvents', {
              calid: calId,
              eventid: event.id
            })
          }

          // Tilføj event til brugerens specifikke kategorier
          if (usersWithEvents[calId]) {
            state.allUsersAndEvents[calId].dayAllEvents.push(event.id)
            const treatAwayAsAbsence = event.away && !usersWithRealAbsence[calId]
            if (event.event_type === 'absence' || treatAwayAsAbsence) {
              state.allUsersAndEvents[calId].dayAbsence.push(event.id)
              if (event.event_serial_id) {
                Vue.set(state.allAbsenceEventInEventSerialIdsHash, event.event_serial_id, event)
              }
            } else if (event.away && usersWithRealAbsence[calId]) {
              if (event.canceled) {
                state.allUsersAndEvents[calId].canceledEvents.push(event.id)
              }
              state.allUsersAndEvents[calId].dayEvents.push(event.id)
            } else if (event.event_type === null || event.event_type === 'presence') {
              state.allUsersAndEvents[calId].dayPresence.push(event.id)
            } else {
              if (event.event_type === 'available') {
                state.allUsersAndEvents[calId].dayAvailability.push(event.id)
              }
              if (event.canceled) {
                state.allUsersAndEvents[calId].canceledEvents.push(event.id)
              }
              state.allUsersAndEvents[calId].dayEvents.push(event.id)
            }

            // Find substitutes Today
            // is_substitute covers substitutes without anyone to cover for
            if (calendarEvent.substitute || calendarEvent.is_substitute || calendarEvent.substitute_for_user_id) {
              state.allUsersAndEvents[calId].daySubEvents.push(event.id)
            }
          }
        }
      }
    }

    let usersWithEventsInArry = Object.keys(usersWithEvents).map(key => {
      return usersWithEvents[key]
    })
    state.usersWithEvents = usersWithEventsInArry
    state.dataIsLoading = false
    console.timeEnd('vuex::setAllEventsOnUsers')
  }
}

const actions = {
  updateStatusOnActiveEvents: (context, status) => {
    context.state.isActiveEventsLoading = true
    const updates = {}
    context.state.activeEvents.forEach(event => {
      const lesson = event.lesson
      let statusData = lesson.substitution_status ? JSON.parse(lesson.substitution_status) : {}
      statusData[event.calendar_id] = {'status': status * 1}
      const eventMap = {
        event_id: event.event_id,
        substitution_status: JSON.stringify(statusData)
      }
      const schoolId = event && event.school_id ? event.school_id : null
      if (!updates[schoolId]) {
        updates[schoolId] = [eventMap]
      } else {
        updates[schoolId].push(eventMap)
      }
    })
    const successTxt = window.use_i18n.t('vue2.substitution.lessons_updated') // 'Opdateret' // this.$t('vue2.substitution.lessons_updated')
    const errorTxt = 'Something went wrong' // this.$t('vue2.common.something_went_wrong')
    Object.keys(updates).forEach(schoolId => {
      docendo.updateEvents(schoolId, updates[schoolId], success => {
        context.state.activeEvents = []
        context.state.isActiveEventsLoading = false
        success.forEach(event => {
          const lesson = JSON.parse(event)
          context.commit('updateEventOnAllEventsInAHash', lesson)
        })
        eventbus.toast = {text: successTxt, success: true}
      }, failure => {
        context.state.isActiveEventsLoading = false
        eventbus.toast = {text: errorTxt, success: false}
      })
    })
  },
  addSubToActiveEvents: (context, userCalendarId) => {
    context.state.isActiveEventsLoading = true
    context.state.theActiveEventsLoadingOnCalendarId = userCalendarId
    const updates = {}
    context.state.activeEvents.forEach(event => {
      const eventMap = {
        event_id: event.event_id,
        calendar_id: event.calendar_id,
        add_substitute_calendar_id: userCalendarId
      }
      const schoolId = event && event.school_id ? event.school_id : null
      if (!updates[schoolId]) {
        updates[schoolId] = [eventMap]
      } else {
        updates[schoolId].push(eventMap)
      }
    })
    const successTxt = window.use_i18n.t('vue2.substitution.lessons_updated') // 'Opdateret' // this.$t('vue2.substitution.lessons_updated')
    const errorTxt = 'Something went wrong' // this.$t('vue2.common.something_went_wrong')
    Object.keys(updates).forEach(schoolId => {
      docendo.updateEvents(schoolId, updates[schoolId], success => {
        context.state.activeEvents = []
        context.state.isActiveEventsLoading = false
        context.state.theActiveEventsLoadingOnCalendarId = null
        success.forEach(event => {
          const lesson = JSON.parse(event)
          context.commit('updateEventOnAllEventsInAHash', lesson)
          const userEventObj = {cal_id: userCalendarId, event_id: lesson.id}
          context.commit('addEventOnAllUsersWithEvents', userEventObj)
        })
        eventbus.toast = {text: successTxt, success: true}
      }, failure => {
        context.state.isActiveEventsLoading = false
        context.state.theActiveEventsLoadingOnCalendarId = null
        eventbus.toast = {text: errorTxt, success: false}
      })
    })
  },
  getAllUsers: (context, schoolId, userIdsFilter) => {
    docendo.schoolUsers(window.SCHOOL.id, userIdsFilter, (data) => {
      context.commit('setAllUsers', data)
    })
  },
  readAllEvents: (context, storeObj) => {
    const activeSchoolId = window.SCHOOL.id * 1
    const events = []
    const requestId = ++context.state.eventsRequestId
    const requestedDate = moment(context.state.date).format('YYYY-MM-DD')
    context.state.dataIsLoading = true
    docendo.listEventsForSchools(storeObj.schoolIds, requestedDate, data => {
      if (requestId !== context.state.eventsRequestId) {
        return
      }
      if (moment(context.state.date).format('YYYY-MM-DD') !== requestedDate) {
        return
      }
      if (data.status === 'error') {
        // If user is not member of both schools
        context.dispatch('getAllDayEvents')
      } else {
        const parsedData = JSON.parse(data)
        parsedData.forEach(event => {
          const idx = events.findIndex(lesson => lesson.id === event.id)
          if (idx < 0) {
            if (!storeObj.isShowEventsFromOtherThanActiveSchool && (event.school_id * 1) !== activeSchoolId) {
              Vue.set(event, 'v_is_event_from_other_school', true)
            }
            events.push(event)
          }
        })
        context.commit('setAllEventsOnUsers', events)
      }
    }, failure => {
      if (requestId !== context.state.eventsRequestId) {
        return
      }
      // If the user is not member of the other school
      window.alert('Something went wrong')
      context.state.dataIsLoading = false
      context.commit('setAllEventsOnUsers', events)
    })
  },
  getAllDayEvents: (context) => {
    const requestId = ++context.state.eventsRequestId
    const requestedDate = moment(context.state.date).format('YYYY-MM-DD')
    context.state.dataIsLoading = true
    docendo.listEvents(window.SCHOOL.id, requestedDate, data => {
      if (requestId !== context.state.eventsRequestId) {
        return
      }
      if (moment(context.state.date).format('YYYY-MM-DD') !== requestedDate) {
        return
      }
      context.commit('setAllEventsOnUsers', JSON.parse(data))
    })
  },
  getUserSubPools: (context) => {
    docendo.schoolSubstituteHours(window.SCHOOL.id, data => {
      context.commit('setUsersWithSubPools', data)
    })
  },
  subsGetAbsenceReasons: (context) => {
    docendo.schoolAbsenceSubjectsList(window.SCHOOL.id, false, data => {
      context.commit('subsSetAbsenceReasons', data)
    })
  },
  subsGetLongAbsenceList: (context) => {
    docendo.schoolEventSerialsList(window.SCHOOL.id, context.state.date, data => {
      context.commit('subsSetLongAbsentList', data)
    })
  },
  setActiveSchedulerEvent: (context, data) => {
    context.state.schedulerActiveEvent = data
    if (!context.state.isSortSubActive || !data.userIsAbsent || data.obj.event_type === 'absence') {
      return
    }
    console.time('subScore')
    let overlappingEvents = {
      absence: {},
      available: {},
      presence: {},
      severalOnLesson: {},
      lessonsInSameClass: {},
      lessons: {},
      multipleLessonsInSameClasses: {},
      canceledHours: {},
      hasHoursInClassOnDay: {}
    }
    let otherOnlessonHash = {}
    let overlappingLessonsInClassHash = {}

    // "Også tilknyttet"
    if (data.othersOnLesson) {
      otherOnlessonHash = data.othersOnLesson.reduce((obj, item) => {
        obj[item.user_calendar_id] = item
        return obj
      }, {})
    }
    if (data.overlappingEvents) {
      data.overlappingEvents.forEach(event => {
        switch (event.event_type) {
          case 'absence':
            event.calendar_events.forEach(cal => {
              overlappingEvents.absence[cal.calendar_id] = cal.calendar_id
            })
            break
          case 'available':
            event.calendar_events.forEach(cal => {
              overlappingEvents.available[cal.calendar_id] = cal.calendar_id
            })
            break
          case 'presence':
            let overlapping = moment(context.state.schedulerActiveEvent.obj.start).isBetween(event.start, event.end, null, '[]') && moment(context.state.schedulerActiveEvent.obj.end).isBetween(event.start, event.end, null, '[]')
            event.calendar_events.forEach(cal => {
              if (overlapping) {
                overlappingEvents.presence[cal.calendar_id] = cal.calendar_id
              }
            })
            break
          case null:
            let overlap = moment(context.state.schedulerActiveEvent.obj.start).isBetween(event.start, event.end, null, '[]') && moment(context.state.schedulerActiveEvent.obj.end).isBetween(event.start, event.end, null, '[]')
            event.calendar_events.forEach(cal => {
              if (overlap) {
                overlappingEvents.presence[cal.calendar_id] = cal.calendar_id
              }
            })
            break
          default:
            // Aflyste lektioner i tidsrummet: markér som fri med aflyste timer (optager ikke)
            if (event.canceled) {
              event.calendar_events.forEach(cal => {
                if (context.state.allUsersAndEvents[cal.calendar_id]) {
                  overlappingEvents.canceledHours[cal.calendar_id] = cal.calendar_id
                }
              })
              break
            }
            event.calendar_events.forEach(cal => {
              let arrOfCalIdsOnActiveEvent = context.state.schedulerActiveEvent.obj.calendar_events.map(cal => cal.calendar_id)
              // Er på en anden brik i klassen på samme tid
              if (event.id !== context.state.schedulerActiveEvent.obj.id && arrOfCalIdsOnActiveEvent.indexOf(cal.calendar_id) > -1) {
                event.calendar_events.forEach(cal => {
                  overlappingEvents.lessonsInSameClass[cal.calendar_id] = cal.calendar_id
                })
                // Look up overlapping cal type?
                // if (context.rootGetters['allCalendarsInHash'][cal.calendar_id] && context.rootGetters['allCalendarsInHash'][cal.calendar_id]) {}
              }

              // overlappingLessonsInClassHash = {klasse: [eventid, eventid], 122: [332211]}
              if (context.rootGetters.allKlassCalendarsInHash[cal.calendar_id]) {
                if (!overlappingLessonsInClassHash[cal.calendar_id]) {
                  overlappingLessonsInClassHash[cal.calendar_id] = [event.id]
                } else {
                  overlappingLessonsInClassHash[cal.calendar_id].push(event.id)
                }
              }
              if (context.state.allUsersAndEvents[cal.calendar_id]) {
                // +2 undervisere på samme lektion (ikke-substitutter)
                const teachersOnLesson = event.calendar_events.filter(ce =>
                  ce.calendar_type === 'user' && !ce.substitute
                )
                if (teachersOnLesson.length >= 2) {
                  overlappingEvents.severalOnLesson[cal.calendar_id] = cal.calendar_id
                } else {
                  overlappingEvents.lessons[cal.calendar_id] = cal.calendar_id
                }
              }
            })
            break
        }
      })
    }
    // Lav array om til bruger_id'er
    // Find de props, hvor der er mere end 1 i
    Object.entries(overlappingLessonsInClassHash).forEach((eventIds, key) => {
      if (eventIds[1].length > 1) {
        eventIds[1].forEach(eventId => {
          context.state.allEventsInAHash[eventId].calendar_events.forEach(cal => {
            if (context.state.allUsersAndEvents[cal.calendar_id]) {
              overlappingEvents.multipleLessonsInSameClasses[cal.calendar_id] = eventIds[0]
            }
          })
        })
      }
    })

    // Hvem har ellers timer i klassen på dagen (ikke nødvendigvis samtidig)
    const activeEvent = context.state.schedulerActiveEvent.obj
    const skippedEventTypes = {absence: true, available: true, presence: true, reservation: true}
    const activeKlassCalIds = (activeEvent.calendar_events || [])
      .filter(cal => context.rootGetters.allKlassCalendarsInHash[cal.calendar_id])
      .map(cal => cal.calendar_id)
    activeKlassCalIds.forEach(klassCalId => {
      const calData = context.state.allCalsWithEventIdsInHash[klassCalId]
      if (!calData || !calData.lessons) {
        return
      }
      calData.lessons.forEach(eventId => {
        if (eventId === activeEvent.id) {
          return
        }
        const event = context.state.allEventsInAHash[eventId]
        if (!event || event.canceled || event.away || skippedEventTypes[event.event_type] || event.event_type === null) {
          return
        }
        event.calendar_events.forEach(cal => {
          if (context.state.allUsersAndEvents[cal.calendar_id]) {
            overlappingEvents.hasHoursInClassOnDay[cal.calendar_id] = klassCalId
          }
        })
      })
    })

    context.state.allUsers.forEach(user => {
      context.state.allUsersAndEvents[user.user_calendar_id].subScore = new Array(36).fill(0)
      let subScoreTags = 0
      let subScoreSubPools = 0 // user.subPoolsDiff * 0.01 > 0 ? user.subPoolsDiff * 0.01 : 0
      if (!data.user) {
        return
      }
      // Tags
      data.user.user_tags.forEach(userTag => {
        user.user_tags.forEach(subTag => {
          if (subTag === userTag) {
            subScoreTags < 10 ? subScoreTags++ : null
          }
        })
      })
      // Har aflyste timer der overlapper den klikkede lektion (og ikke optaget af anden lektion)
      const isOccupiedByLesson = !!overlappingEvents.lessons[user.user_calendar_id]
      if (
        overlappingEvents.canceledHours[user.user_calendar_id] &&
        !isOccupiedByLesson &&
        context.state.sortingHierarchy.canceledHours !== undefined
      ) {
        context.state.allUsersAndEvents[user.user_calendar_id].subScore[context.state.sortingHierarchy.canceledHours] = 1
        context.state.allUsersAndEvents[user.user_calendar_id].subScore[context.state.sortingHierarchy.canceledHours + 1] = subScoreTags
        context.state.allUsersAndEvents[user.user_calendar_id].subScore[context.state.sortingHierarchy.canceledHours + 2] = subScoreSubPools
      }
      // "Også tilknyttet"
      if (otherOnlessonHash[user.user_calendar_id]) {
        context.state.allUsersAndEvents[user.user_calendar_id].subScore[context.state.sortingHierarchy.othersOnLesson] = 1
        context.state.allUsersAndEvents[user.user_calendar_id].subScore[context.state.sortingHierarchy.othersOnLesson + 1] = subScoreTags
        context.state.allUsersAndEvents[user.user_calendar_id].subScore[context.state.sortingHierarchy.othersOnLesson + 2] = subScoreSubPools
      }

      // Er i samme klasse på samme tidspunkt
      if (overlappingEvents.lessonsInSameClass[user.user_calendar_id]) {
        context.state.allUsersAndEvents[user.user_calendar_id].subScore[context.state.sortingHierarchy.isInSameClassAtTheSameTime] = 1
        context.state.allUsersAndEvents[user.user_calendar_id].subScore[context.state.sortingHierarchy.isInSameClassAtTheSameTime + 1] = subScoreTags
        context.state.allUsersAndEvents[user.user_calendar_id].subScore[context.state.sortingHierarchy.isInSameClassAtTheSameTime + 2] = subScoreSubPools
      }

      // Har ellers timer i klassen på dagen
      if (
        overlappingEvents.hasHoursInClassOnDay[user.user_calendar_id] &&
        context.state.sortingHierarchy.hasHoursInClassOnDay !== undefined
      ) {
        context.state.allUsersAndEvents[user.user_calendar_id].subScore[context.state.sortingHierarchy.hasHoursInClassOnDay] = 1
        context.state.allUsersAndEvents[user.user_calendar_id].subScore[context.state.sortingHierarchy.hasHoursInClassOnDay + 1] = subScoreTags
        context.state.allUsersAndEvents[user.user_calendar_id].subScore[context.state.sortingHierarchy.hasHoursInClassOnDay + 2] = subScoreSubPools
      }

      // Er to eller flere i en anden klasse på samme tidspunk
      if (overlappingEvents.multipleLessonsInSameClasses[user.user_calendar_id]) {
        context.state.allUsersAndEvents[user.user_calendar_id].subScore[context.state.sortingHierarchy.multipleLessonsInSameClasses] = 1
        context.state.allUsersAndEvents[user.user_calendar_id].subScore[context.state.sortingHierarchy.multipleLessonsInSameClasses + 1] = overlappingEvents.multipleLessonsInSameClasses[user.user_calendar_id] // the klassCalId so two users from same class is next to eachother
        context.state.allUsersAndEvents[user.user_calendar_id].subScore[context.state.sortingHierarchy.multipleLessonsInSameClasses + 2] = subScoreSubPools
      }

      if (overlappingEvents.lessons[user.user_calendar_id]) {
        // IKke noget hvis optaget
      } else if (overlappingEvents.severalOnLesson[user.user_calendar_id]) {
        // hvis 2 på en lektion
        context.state.allUsersAndEvents[user.user_calendar_id].subScore[context.state.sortingHierarchy.multipleLessonsInSameClasses] = 1
        context.state.allUsersAndEvents[user.user_calendar_id].subScore[context.state.sortingHierarchy.multipleLessonsInSameClasses + 1] = subScoreTags
        context.state.allUsersAndEvents[user.user_calendar_id].subScore[context.state.sortingHierarchy.multipleLessonsInSameClasses + 2] = subScoreSubPools
      } else {
        // Ikke optaget && "Rådighedstime"
        if (overlappingEvents.available[user.user_calendar_id]) {
          context.state.allUsersAndEvents[user.user_calendar_id].subScore[context.state.sortingHierarchy.availableHour] = 1
          context.state.allUsersAndEvents[user.user_calendar_id].subScore[context.state.sortingHierarchy.availableHour + 1] = subScoreTags
          context.state.allUsersAndEvents[user.user_calendar_id].subScore[context.state.sortingHierarchy.availableHour + 2] = subScoreSubPools
        }
        // Ikke optaget && "Tilstedeværelse"
        if (overlappingEvents.presence[user.user_calendar_id]) {
          context.state.allUsersAndEvents[user.user_calendar_id].subScore[context.state.sortingHierarchy.presence] = 1
          context.state.allUsersAndEvents[user.user_calendar_id].subScore[context.state.sortingHierarchy.presence + 1] = subScoreTags
          context.state.allUsersAndEvents[user.user_calendar_id].subScore[context.state.sortingHierarchy.presence + 2] = subScoreSubPools
        }
        // Ikke optaget m. lektioner på dagen u. overlappende tilstedeværelse
        if (context.state.allUsersAndEvents[user.user_calendar_id].dayEvents.length > 0) {
          context.state.allUsersAndEvents[user.user_calendar_id].subScore[context.state.sortingHierarchy.notOccupiedWithLessonsOnDay] = 1
          context.state.allUsersAndEvents[user.user_calendar_id].subScore[context.state.sortingHierarchy.notOccupiedWithLessonsOnDay + 1] = subScoreTags
          context.state.allUsersAndEvents[user.user_calendar_id].subScore[context.state.sortingHierarchy.notOccupiedWithLessonsOnDay + 2] = subScoreSubPools
        } else {
          // Ikke optaget u. lektioner på dagen u. overlappende tilstedeværelse
          context.state.allUsersAndEvents[user.user_calendar_id].subScore[context.state.sortingHierarchy.notOccupiedWithoutLessonsOnDay] = 1
          context.state.allUsersAndEvents[user.user_calendar_id].subScore[context.state.sortingHierarchy.notOccupiedWithoutLessonsOnDay + 1] = subScoreTags
          context.state.allUsersAndEvents[user.user_calendar_id].subScore[context.state.sortingHierarchy.notOccupiedWithoutLessonsOnDay + 2] = subScoreSubPools
        }
      }
      // TO string
      context.state.allUsersAndEvents[user.user_calendar_id].subScore = context.state.allUsersAndEvents[user.user_calendar_id].subScore.join('')
    })
    context.state.sortSubs++
    console.timeEnd('subScore')
  },
  updateIsSubZenActive (context, boolean) {
    context.commit('setIsSubScoreActive', boolean)
    context.dispatch('updateUserSettings', {'isSubZenActive': boolean})
  },
  removeSubsOnActiveEvents: (context) => {
    context.dispatch('trackEvent', 'substitution_popover_removeMultipleSubstitutes')
    context.state.isActiveEventsLoading = true
    // group active events by absent user's calendar_id
    const eventsByCalId = {}
    context.state.activeEvents.forEach(evt => {
      const calId = evt.calendar_id
      if (!eventsByCalId[calId]) {
        eventsByCalId[calId] = []
      }
      eventsByCalId[calId].push(evt)
    })
    const requests = []
    Object.keys(eventsByCalId).forEach(calIdStr => {
      const calId = Number(calIdStr)
      const absentUser = context.state.allUsersAndEvents[calId]
      if (!absentUser) {
        return
      }
      const userId = absentUser.id
      const statusData = {}
      statusData[calId] = {'status': 0}
      // group these events by school_id for efficient API calls
      const eventsForUser = eventsByCalId[calId]
      const bySchool = {}
      eventsForUser.forEach(ev => {
        if (!bySchool[ev.school_id]) {
          bySchool[ev.school_id] = [ev]
        } else {
          bySchool[ev.school_id].push(ev)
        }
      })
      Object.keys(bySchool).forEach(schoolIdStr => {
        const schoolId = Number(schoolIdStr)
        const eventIds = bySchool[schoolId].map(e => e.event_id)
        requests.push(new Promise((resolve) => {
          docendo.removeSubstitutionOfUser(schoolId, eventIds, userId, statusData, success => {
            const data = success.length > 0 ? JSON.parse(success) : []
            data.forEach(event => {
              if (moment(event.start).format('YYYY_MM_DD') === moment(context.state.date).format('YYYY_MM_DD')) {
                const before = context.state.allEventsInAHash[event.id]
                context.commit('updateEventOnAllEventsInAHash', event)
                if (before && before.calendar_events) {
                  const diffCals = before.calendar_events.filter(o => !event.calendar_events.some(i => i.id === o.id))
                  diffCals.forEach(cal => {
                    context.commit('removeEventOnAllUsersWithEvents', {
                      cal_id: cal.calendar_id,
                      event_id: event.id
                    })
                  })
                }
              }
            })
            resolve(true)
          }, failure => {
            // resolve to continue other requests; toast will indicate failure
            resolve(false)
          })
        }))
      })
    })
    Promise.all(requests).then(results => {
      context.state.activeEvents = []
      context.state.isActiveEventsLoading = false
      const allOk = results.every(r => r === true)
      if (allOk) {
        eventbus.toast = {text: window.use_i18n.t('vue2.subs_ongoing_absence.subs_removed'), success: true}
      } else {
        eventbus.toast = {text: window.use_i18n.t('vue2.subs_ongoing_absence.subs_remove_failed'), success: false}
      }
    })
  },
  updateSortingHierarchy (context, obj) {
    let userSettingsObj = {'subZenOrder': obj}
    context.dispatch('updateUserSettings', userSettingsObj)
    context.commit('setSortingHierarchy', obj)
  },
  updateEventsSerial (context, obj) {
    docendo.schoolEventSerialsUpdate(obj.school_id, obj.id, obj.calendar_id, obj.subject_id, obj.from_date, obj.to_date, obj.from_time, obj.to_time, obj.ongoing, obj.internal_note, obj.employment_id || null, !!obj.use_time, obj.additional_data || null, success => {
      const data = JSON.parse(success)
      // json_payload mangler employment_id/additional_data — bevar dem fra requesten
      if (obj.employment_id !== undefined) data.employment_id = obj.employment_id
      if (obj.additional_data !== undefined) data.additional_data = obj.additional_data
      if (obj.use_time !== undefined) data.use_time = obj.use_time
      context.commit('updateLongListAbsence', data)
      context.dispatch('getAllDayEvents')
      eventbus.toast = {text: window.use_i18n.t('vue2.subs_ongoing_absence.absence_updated'), 'success': true}
    }, failure => {
      console.log('failed', failure)
    })
  },
  removeSubsFromEvents (context, obj) {
    const statusData = {}
    statusData[obj.user_calendar_id] = {'status': 0}
    const userId = obj.userId

    // Group events by school_id
    const eventsObj = {}
    obj.events.forEach(event => {
      if (!eventsObj[event.school_id]) {
        eventsObj[event.school_id] = [event]
      } else {
        eventsObj[event.school_id].push(event)
      }
    })

    // Iterate over each school_id and make API call to remove substitutions
    Object.keys(eventsObj).forEach(prop => {
      const schoolId = Number(prop)  // Convert prop to a number
      const eventIds = eventsObj[prop].map(event => event.event_id)

      // Call API to remove substitutions for the user
      docendo.removeSubstitutionOfUser(schoolId, eventIds, userId, statusData, success => {
        const data = success.length > 0 ? JSON.parse(success) : []

        data.forEach(event => {
          // Check if the event is on the same day
          if (moment(event.start).format('YYYY_MM_DD') === moment(context.state.date).format('YYYY_MM_DD')) {
            let eventBeforeUpdate = context.state.allEventsInAHash[event.id]
            context.commit('updateEventOnAllEventsInAHash', event)
            let diffCals = eventBeforeUpdate.calendar_events.filter(o => !event.calendar_events.some(i => i.id === o.id))
            // Remove events from all users i substitution
            diffCals.forEach(cal => {
              context.commit('removeEventOnAllUsersWithEvents', {
                cal_id: cal.calendar_id,  // Identify the calendar ID
                event_id: event.id
              })
            })
          }
        })
        eventbus.toast = {
          text: window.use_i18n.t('vue2.subs_ongoing_absence.subs_removed'),
          success: true
        }
      }, failure => {
        console.log('API call failure:', failure)

        eventbus.toast = {
          text: window.use_i18n.t('vue2.subs_ongoing_absence.subs_remove_failed'),
          success: false
        }
      })
    })
  },
  deleteAbsence (context, reasonObj) {
    const deletedOnDate = moment(context.state.date).format('YYYY-MM-DD')
    const applyLocalDelete = (calId, eventId) => {
      if (moment(context.state.date).format('YYYY-MM-DD') !== deletedOnDate) {
        return
      }
      invalidateInFlightEventReloads(context.state)
      context.commit('removeAbsenceOnAllUsersWithEvents', {
        cal_id: calId,
        event_id: eventId
      })
      context.commit('reclassifyAwayEventsForUser', calId)
    }
    if (reasonObj.event_serial_id) {
      docendo.schoolEventSerialsDelete(window.SCHOOL.id, reasonObj.event_serial_id, (success) => {
        applyLocalDelete(reasonObj.user_calendar_id, reasonObj.id)
        context.commit('deleteLongListAbsenceItem', {
          eventSerialId: reasonObj.event_serial_id
        })
        eventbus.toast = {text: window.use_i18n.t('vue2.subs_ongoing_absence.absence_deleted'), 'success': true}
      })
    } else {
      docendo.deleteEvent(window.SCHOOL.id, reasonObj.id, data => {
        const parsed = JSON.parse(data)
        applyLocalDelete(parsed.calendar_id, parsed.id)
        eventbus.toast = {text: window.use_i18n.t('vue2.subs_ongoing_absence.absence_deleted'), 'success': true}
      })
    }
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/subs.js